import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=1ed493f7&scoped=true"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"
import style0 from "./Page.vue?vue&type=style&index=0&id=1ed493f7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed493f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed493f7')) {
      api.createRecord('1ed493f7', component.options)
    } else {
      api.reload('1ed493f7', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=1ed493f7&scoped=true", function () {
      api.rerender('1ed493f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/label-layout-editor/Page.vue"
export default component.exports